import { useContext, useEffect, useState } from 'react';
//import {  Modal } from 'react-bootstrap';
import { FaAddressCard } from 'react-icons/fa';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { UpdateSituationAPI } from '../../API/CompaniesAPI';
import { CompanyContext } from '../../Contexts/CompanyContext';
import { IResponseProps } from '../../Interfaces/IResponseProps';
import { ISelectProps } from '../../Interfaces/ISelectProps';
import { AllStatus } from '../../Utils/AllContratTypes';
import { AllSteps } from '../../Utils/AllSteps';
import './styles.css';
import useCan from '../../Hooks/useCan';
import { ProjectModel, ProjectsWithProjectGroupingModel } from '../../Models/ProjectModel';
import TextArea from 'antd/es/input/TextArea';
import { Button, Modal } from 'antd';

interface IModalProjectProps {
    showModal: boolean,
    toggleShowModal: () => void,
    projectItem: ProjectModel
}



const ModalProjectsProjectWithGrouping = (props: IModalProjectProps) => {

    const canView = useCan({ rolesCan: ["Manager", "Consultant"] });
    const { company, getCompany } = useContext(CompanyContext);

    return (
        <>
        <Modal
            title={props.projectItem.name}
            
            footer={<Button className='w-100' onClick={props.toggleShowModal}>
                Fechar
            </Button>}
            
            open={props.showModal}
            onCancel={props.toggleShowModal}
        >
                <div>
                    <h5 className='fw-bold'>Atividades Associadas ao Projeto</h5>
                    <TextArea rows={1} disabled={true} className="h-100 w-100"
                        value={props.projectItem.activities} />
                </div>
                <h5 className='py-3 fw-bold'>Orçamento do Projeto</h5>
                <div className='d-flex justify-content-between align-items-center rounded bg-light'>
                    <h6 className='p-2 ms-3 m-0'>Orçamento Total</h6>
                    <h6 className='p-2 me-3 m-0'>{"R$ " + new Intl.NumberFormat("pt-BR", {
                        minimumFractionDigits: 2,
                    }).format(props.projectItem.budget)}</h6>
                </div>
            </Modal></>

        
    )
}

export default ModalProjectsProjectWithGrouping;